export const setRFIndexers = ({ commit }, payload) => {
  commit('SET_RFINDEXERS', payload)
}
export const setRFIndexersLoading = ({ commit }, payload) => {
  commit('SET_RFINDEXERS_LOADING', payload)
}

export const setFeeModels = ({ commit }, payload) => {
  commit('SET_FEE_MODELS', payload)
}
export const addFeeModels = ({ commit }, payload) => {
  commit('ADD_FEE_MODELS', payload)
}
export const setFeeModelsLoading = ({ commit }, payload) => {
  commit('SET_FEE_MODELS_LOADING', payload)
}

export const setPortfolioModels = ({ commit }, payload) => {
  commit('SET_PORTFOLIO_MODELS', payload)
}
export const addPortfolioModels = ({ commit }, payload) => {
  commit('ADD_PORTFOLIO_MODELS', payload)
}
export const setPortfolioModelsLoading = ({ commit }, payload) => {
  commit('SET_PORTFOLIO_MODELS_LOADING', payload)
}
export const setCurrencies = ({ commit }, payload) => {
  commit('SET_CURRENCIES', payload)
}
export const addCurrencies = ({ commit }, payload) => {
  commit('ADD_CURRENCIES', payload)
}
export const setCurrenciesLoading = ({ commit }, payload) => {
  commit('SET_CURRENCIES_LOADING', payload)
}

